import debounce from '/src/scripts/helpers/debounce';
import HashScrolling from '/src/scripts/hash-scrolling';

export default class EventsSearchForm {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.events-search-form'), el => {
			new EventsSearchForm(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
        this.overrideDate = null;

        element.querySelector('form').addEventListener('submit', e => {
            e.preventDefault();
            this.onChangeDebounced();
            HashScrolling.scrollToLinkHash('#event-list');
        });
        element.querySelector('.events-search-form__search-input input').addEventListener('keydown', () => this.onChangeDebounced());
        element.querySelector('.events-search-form__search-input input').addEventListener('autocomplete-select', () => this.onChangeDebounced(true)); // see Searchbox.js
        element.querySelector('.events-search-form__category-select .multiselect__data-holder-tags').addEventListener('change', () => this.onChangeDebounced(true));
        element.querySelector('.events-search-form__datepicker').addEventListener('preselect', (e) => {
            if (!e.detail[1]) { // no end date
                let startDate = e.detail[0].format('YYYY-MM-DD');
                this.overrideDate = startDate + ' - ' + startDate;
            } else {
                this.overrideDate = null;
            }
            this.onChangeDebounced(true);
        });
        element.querySelector('.events-search-form__for-families-input').addEventListener('change', () => this.onChangeDebounced(true));
        element.querySelector('.events-search-form__only-top-events-input').addEventListener('change', () => this.onChangeDebounced(true));
        //Array.from(element.querySelectorAll('.events-search-form__audience-type-select .radio')).forEach(input => input.addEventListener('change', this.onChange));

        document.addEventListener('click', e => {
            const { target } = e;
            if (target.matches('.events-pagination a')) {
                e.preventDefault();
                this.updateList(target.getAttribute('href'));
                HashScrolling.scrollToLinkHash('#event-list');
            }
        });
	}

    onChangeDebounced = debounce((scrollToLinkHashIfIsAbove) => {
        // get the target uri
        const form = this.element.querySelector('form');
        const formData = new FormData(form);
        const params = new URLSearchParams(formData);
        if (this.overrideDate) {
            params.set('daterange', this.overrideDate);
        }

        let action = form.getAttribute('action');
        const uri = action ? action.replace('#event-list', '') + '?' + params.toString() + '#event-list' : '';
        this.updateList(uri);

        if (scrollToLinkHashIfIsAbove) HashScrolling.scrollToLinkHashIfIsAbove('#events-search-form');
    }, 300)

    updateList(uri) {
        if (this.latestSearchUri === uri) {
            return // already searching for this
        }
        this.latestSearchUri = uri;
        // very naiv implementation, we expect one list to be available, should be refactored by Roland
        let collection = document.querySelector('.events-paginated-collection');
        let collectionLoader = document.querySelector('.events-paginated-collection-loader');
		collection ? collection.classList.add('events-paginated-collection--is-hidden') : false;
		collectionLoader ? collectionLoader.classList.remove('events-paginated-collection-loader--is-hidden') : false;

        // update uri
        if (window.history) history.pushState({}, '', uri);

        // fetch from server
        fetch(uri)
            .then(response => response.text())
            .then(html => {
                if (uri !== this.latestSearchUri) {
                    return; // already searching for something else
                }

                // replace search results
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                document.getElementById('event-list').innerHTML = doc.getElementById('event-list').innerHTML;
            })
			.catch(() => {
                // window.location = uri;
            });
    }
}
